<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Distribución: <strong>{{ data.campaign.name }}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6>
            <span *ngIf="distributions"> <mat-icon class="align-middle">update</mat-icon> Última actualización: <strong>{{ distributions[0].created_at | date : "dd/MM/yyyy hh:mma": "-0000" }} {{ " - " + distributions[0].user }}</strong></span>
        </h6>
        <h6 class="pb-4">
            <span class="align-middle">Lista de Archivos Distribución</span>
            <div class="float-end align-middle">
                <a *ngIf="distributions && isDriveUrl(distributions[0]?.url)" [href]="distributions[0]?.url" target="_blank" mat-stroked-button color="primary">Descarga último archivo <mat-icon class="align-middle ms-1">file_download</mat-icon></a>
                <button *ngIf="distributions && isDigitalOceanSpacesUrl(distributions[0]?.url)" (click)="openDistributionPreview(distributions[0])" mat-stroked-button color="primary">Ver último archivo <mat-icon class="align-middle ms-1">visibility</mat-icon></button>
                <button mat-flat-button color="primary" class="ms-4" *ngIf="isUnlocked&&canUploadDis" (click)="openDialogUploadDistFile()">Subir archivo
                    <mat-icon>upload_file</mat-icon>
                </button>
            </div>
        </h6>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <mat-divider></mat-divider>
        <div>
            <div class="row g-2">
                <div class="col mb-0">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Archivo</th>
                                    <th>Responsable</th>
                                    <th>Fecha de Registro</th>
                                    <th>Equipo</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let distribution of distributions">
                                    <td>
                                        {{ distribution.id }}
                                    </td>
                                    <td>
                                        <a *ngIf="isDriveUrl(distribution.url)" [href]="distribution.url" target="_blank">
                                            {{ distribution.file_name }}
                                        </a>
                                        <button *ngIf="isDigitalOceanSpacesUrl(distribution.url)" class="btn btn-link p-0" (click)="openDistributionPreview(distribution)">
                                            {{ distribution.file_name }}
                                        </button>
                                    </td>
                                    <td>
                                        {{ distribution.user }}
                                    </td>
                                    <td>
                                        {{ distribution.created_at | date : "dd/MM/yyyy hh:mma": "-0000" }}
                                    </td>
                                    <td>
                                        <span class="badge {{distribution.id_rol==3?'bg-info':'bg-warning'}}">{{distribution.rol}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
